import { render, staticRenderFns } from "./EventPackageOffersNotAvailableWarning.vue?vue&type=template&id=49be5ddc&scoped=true&"
import script from "./EventPackageOffersNotAvailableWarning.vue?vue&type=script&lang=js&"
export * from "./EventPackageOffersNotAvailableWarning.vue?vue&type=script&lang=js&"
import style0 from "./EventPackageOffersNotAvailableWarning.vue?vue&type=style&index=0&id=49be5ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be5ddc",
  null
  
)

export default component.exports